import React from "react";
import PropTypes from "prop-types";
import { Link, NavLink, Route } from "react-router-dom";
import { createMissingAccessVouchers } from "../../../../services/api/accessVouchers";
import { ajaxErrorHandler } from "../../../../libs/utils";

class VouchersHeadr extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this._generateAccessVouchers = this._generateAccessVouchers.bind(this);
  }

  static propTypes = {
    event: PropTypes.object
  };

  _generateAccessVouchers() {
    createMissingAccessVouchers(this.props.event.id)
      .then(response => {
        window.location.reload();
      })
      .catch(ajaxErrorHandler);
  }

  render() {
    const { event } = this.props;
    return (
      <div className="m-portlet__head">
        <div className="m-portlet__head-caption">
          <div className="m-portlet__head-title">
            <h3 className="m-portlet__head-text">
              <Route
                path="/admin/events/:id/vouchers/access"
                render={() => "Access Vouchers"}
              />
              <Route
                path="/admin/events/:id/vouchers/parking"
                render={() => "Parking Vouchers"}
              />
              <Route
                path="/admin/events/:id/vouchers/transport"
                render={() => "Transport Vouchers"}
              />
            </h3>
          </div>
        </div>
        <div className="m-portlet__head-tools">
          <ul className="m-portlet__nav m--margin-left-20">
            <li className="m-portlet__nav-item">
              <Route
                exact
                path="/admin/events/:id/vouchers/access"
                render={() => (
                  <button
                    type="buttons"
                    key="generate"
                    className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon m--margin-right-10"
                    onClick={this._generateAccessVouchers}
                    style={{ marginRight: "10px !important" }}
                  >
                    <span>
                      <i className="la la-fighter-jet" />
                      <span>Generate</span>
                    </span>
                  </button>
                )}
              />
            </li>
            <li className="m-portlet__nav-item">
              <Route
                exact
                path="/admin/events/:id/vouchers/access"
                render={() => [
                  <button
                    type="buttons"
                    key="generate"
                    className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon m--margin-right-10"
                    onClick={this._generateAccessVouchers}
                    style={{ marginRight: "10px !important" }}
                  >
                    <span>
                      <i className="la la-fighter-jet" />
                      <span>Generate</span>
                    </span>
                  </button>,
                  <Link
                    to={"/admin/events/" + event.id + "/vouchers/access/create"}
                    className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon"
                    key="create"
                  >
                    <span>
                      <i className="la la-plus" />
                      <span>Create Access Voucher</span>
                    </span>
                  </Link>
                ]}
              />
              <Route
                exact
                path="/admin/events/:id/vouchers/parking"
                render={() => (
                  <Link
                    to={
                      "/admin/events/" + event.id + "/vouchers/parking/create"
                    }
                    className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon"
                  >
                    <span>
                      <i className="la la-plus" />
                      <span>Create Parking Voucher</span>
                    </span>
                  </Link>
                )}
              />
              <Route
                exact
                path="/admin/events/:id/vouchers/transport"
                render={() => (
                  <Link
                    to={
                      "/admin/events/" + event.id + "/vouchers/transport/create"
                    }
                    className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon"
                  >
                    <span>
                      <i className="la la-plus" />
                      <span>Create Transport Voucher</span>
                    </span>
                  </Link>
                )}
              />
            </li>
          </ul>
          <ul
            className="nav nav-tabs m-tabs m-tabs-line   m-tabs-line--right m-tabs-line-danger"
            role="tablist"
          >
            <li className="nav-item m-tabs__item">
              <NavLink
                className="nav-link m-tabs__link"
                to={"/admin/events/" + event.id + "/vouchers/access"}
              >
                Access
              </NavLink>
            </li>
            <li className="nav-item m-tabs__item">
              <NavLink
                className="nav-link m-tabs__link"
                to={"/admin/events/" + event.id + "/vouchers/parking"}
              >
                Parking
              </NavLink>
            </li>
            <li className="nav-item m-tabs__item">
              <NavLink
                className="nav-link m-tabs__link"
                to={"/admin/events/" + event.id + "/vouchers/transport"}
              >
                Transport
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default VouchersHeadr;
